export const isBannerVisibleToUser = (banner, user) => {
  const allowedRoles = banner?.roles ?? [];
  if (allowedRoles.length === 0) return true;
  const userRoles = user?.roles ?? [];
  return userRoles.some((role) => allowedRoles.includes(role?.key ?? role));
};
